export interface Range {
  lower: string;
  upper: string;
}
export interface Parts {
  major: number[];
  minor: number[];
  patch: number[];
}
